import { constants } from '../../constants'

export function getRelatedItem (relatedItems, refId) {
  let relatedItem = null
  refId = refId.replace('/', '')
  relatedItems.forEach(function (related) {
    if (refId === related.id) {
      relatedItem = related
    }
  })
  return relatedItem
}

export function getLocalizedString (item, key) {
  let lang = constants.languagePaths.de_DE
  if (item) {
    return item.attr[constants.attributePaths[key]][1]
      .attr[constants.attributePaths.name_localized][1]
      .data.localized_strings[lang]
  }
  return ''
}

export function getRelatedValue (item, relatedItems, key) {
  const attributePath = constants.attributePaths[key]
  if (item.attr[attributePath] !== undefined) {
    let refId = item.attr[attributePath][1].data.href
    let relatedItem = getRelatedItem(relatedItems, refId)
    return relatedItem.attr[constants.attributePaths.name][1].data.string
  } else {
    return false
  }
}

export function getItemImages (item, relatedItems, size = '800') {
  let images = []
  if (item && item.attr[constants.attributePaths.images] !== undefined) {
    let refs = item.attr[constants.attributePaths.images][1]
      .attr[constants.attributePaths.images_sub]
    if (refs._ === undefined) {
      refs._ = {
        seq: ['1']
      }
    }
    refs._.seq.forEach((key) => {
      let refId = refs[key].data.href
      let relatedItem = getRelatedItem(relatedItems, refId)

      if (
        relatedItem
        && relatedItem.attr[constants.attributePaths.images_sizes] !== undefined
      ) {
        let published = true
        let sizes = {}
        if (
          relatedItem
            .attr[constants.attributePaths.media_info][1]
            .attr[constants.attributePaths.media_info_published] !== undefined
        ) {
          published = relatedItem
            .attr[constants.attributePaths.media_info][1]
            .attr[constants.attributePaths.media_info_published][1].data.value
        }
        relatedItem.attr[constants.attributePaths.images_sizes]._.seq.forEach((seqSize) => {
          sizes[seqSize] = {
            href: relatedItem
              .attr[constants.attributePaths.images_sizes][seqSize]
              .attr[constants.attributePaths.images_path][1].data.string
          }
        })
        images.push({
          id: refId,
          src: relatedItem
            .attr[constants.attributePaths.images_sizes][size]
            .attr[constants.attributePaths.images_path][1].data.string,
          published: published,
          quality: relatedItem
            .attr[constants.attributePaths.media_info][1]
            .attr[constants.attributePaths.media_info_quality][1].data.value,
          preview: false,
          sizes: sizes
        })
      }
    })
  }
  return images
}

export function getItemImage (item, relatedItems, size = '800') {
  let images = getItemImages(item, relatedItems, size)
  if (images.length) {
    return images[0].src
  }
  return false
}

export function getRating (item) {
  if (item.attr[constants.attributePaths.rating] !== undefined) {
    return item
      .attr[constants.attributePaths.rating][1]
      .attr[constants.attributePaths.rating_sub][1].data.string
  }
  return 0
}

export function getLocation (item) {
  if (item.attr[constants.attributePaths.location][1]) {
    return item.attr[constants.attributePaths.location][1].data
  }
  return null
}
